import { memo } from "react";
import { useSelector } from "react-redux";
import {Helmet} from "react-helmet";
import { STEADILY_URL } from "@/setting";
import { trackButtonClick } from "@/utils/analytics";

const SteadilyBanner = () => {
  // const STEADILY_URL = steadilyURL
  const user = useSelector((state) => state.user?.user);
  const propertyDetails = useSelector((state) => state.pdp.pdpInitData?.propertyDetails);
  return (
    <div className="steadilyContainer pl0"
      onClick={() => {
        trackButtonClick({
          eventName: "steadily_ad_clicked",
          eventCategory: "Steadily form",
          eventSource: "on steadly banner click",
        });
    }}>
      <Helmet>
        <script src={STEADILY_URL} async defer></script>
      </Helmet>
      <div id="steadily" >
        <div
          class="steadily-quote-button"
          data-product="landlord-insurance"
          data-show-modal-on-load="0"
          data-button-text=""
          data-external_record_id=""
          data-primary_insured__first_name={user?.userFirstName || ''}
          data-primary_insured__last_name={user?.userLastName || ''}
          data-primary_insured__company_name=""
          data-primary_insured__email={user?.userEmailId || ''}
          data-primary_insured__phone_number={user?.primaryPhone || ''}
          data-primary_insured__date_of_birth=""
          data-primary_insured__mailing_address__street_address={user?.address1 || ''}
          data-primary_insured__mailing_address__street_address_2={user?.address2 || ''}
          data-primary_insured__mailing_address__city={user?.city || ''}
          data-primary_insured__mailing_address__state={user?.state || ''}
          data-primary_insured__mailing_address__zip_code={user?.zip || ''}
          data-property_details__street_address={propertyDetails?.address?.streetNumber || ''}
          data-property_details__street_address_2={propertyDetails?.address?.streetName || ''}
          data-property_details__city={propertyDetails?.address?.city || ''}
          data-property_details__state={propertyDetails?.address?.state || ''}
          data-property_details__zip_code={propertyDetails?.address?.zip || ''}
          data-property_details__property_type={propertyDetails?.commonAttributes?.subType || ''}
          data-property_details__construction_type=""
          data-property_details__renovation_status=""
          data-property_details__rental_duration=""
          data-property_details__replacement_value=""
          data-property_details__size_sqft={propertyDetails?.commonAttributes?.areaSquareFeet}
          data-property_details__stories=""
          data-property_details__year_built={propertyDetails?.commonAttributes?.yearBuilt || ''}
          data-property_details__external_property_id={propertyDetails?.propertyId || ''}
        />
      </div>
    </div>
  );
};

export default memo(SteadilyBanner);
